// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"4138256c","313":"4138256c","875":"4138256c"}[chunkId] + ".chunk.css";
};